export default __webpack_public_path__ + "static/splash-1-d9e1cb49393b3eceadf2ce257c0c073f.png";